<template>
  <div class="bg-color-darkgray position-relative shadow-sm">
    <div class=" p-4">
      <h3 class="text-white text-center m-4">Inspiration board</h3>
      <div v-if="editable" class="user-profile-card-edit">
        <b-button variant="link" class="btn-link-edit-gray" size="lg" @click.prevent="$emit('edit')">
          <edit-pen-icon :style="{fontSize: '1.5rem'}" />
        </b-button>
      </div>
    </div>
    <div class="p-4">
      <b-img-lazy :src="computedImage" :style="{maxHeight: '550px'}" center fluid />
    </div>
  </div>
</template>

<script>
import EditPenIcon from '@/assets/images/edit-pen.svg'
import { INSPIRATION_DEFAULT } from '@/helpers/constants'

export default {
  name: 'Inspiration',

  props: {
    image: {
      type: String
    },

    editable: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    computedImage() {
      return this.image || INSPIRATION_DEFAULT
    }
  },

  components: {
    EditPenIcon
  }
}
</script>
